import { Building2 } from "lucide-react"
import { Avatar, AvatarFallback, AvatarImage } from "@/components/ui/avatar"
import { cn } from "@/lib/utils"

interface AccountLogoProps {
    logoUrl?: string | null
    name?: string | null
    className?: string
}

export function CompanyLogo({logoUrl, name, className}: AccountLogoProps) {
    return (
        <Avatar className={cn(className)}>
            {logoUrl && (
                <AvatarImage
                    src={logoUrl}
                    alt={name || "Account logo"}
                    className="object-cover"
                />
            )}
            <AvatarFallback className="bg-muted border">
                <Building2 className="size-4 text-muted-foreground"/>
            </AvatarFallback>
        </Avatar>
    )
}